export class BrowserUtil {
    static extractUrlFromQueryParam(url: string) {
        return url.indexOf('?') !== -1 ? url.substring(0, url.indexOf('?')) : url;
    }

    static contains(url, path) {
        if (path === '/') {
            return url === path;
        } else {
            return url.indexOf(path) !== -1;
        }
    }

    static locationEndsWith(endString): boolean {
        return window.location.pathname.endsWith(endString);
    }
}
